//
//
//
//
//
//

export default {
  name: "empty-table"
};